import { render, staticRenderFns } from "./CartList.vue?vue&type=template&id=01b8c06b&scoped=true"
import script from "./CartList.vue?vue&type=script&lang=js"
export * from "./CartList.vue?vue&type=script&lang=js"
import style0 from "./CartList.vue?vue&type=style&index=0&id=01b8c06b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b8c06b",
  null
  
)

export default component.exports